<template lang="pug">
  div(:class="`container-${this._uid} ${this.payload.fields.templateId} ${this.classes}`")
    div(class="section-content")
      section.row(v-for="(n, i) in this.payload.fields.content" :class="n.classes")
        component(v-if="n.sys.contentType.sys.id === 'collection'" is="Collection" :payload="n.fields" :showTitle="true" :clickableItem="true" :key="n.sys.id")
        //- h3.title
          vue-markdown(:source='n.fields.title')
        //- vue-markdown.desc(:source='n.fields.body || n.fields.desc')
    //- h1(class="section-title") {{this.title}}
    div.desc#herodesc
      vue-markdown(:source='this.desc')
      image-block.interactive(:payload="this.image")
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/_sectionBase.js'
import Collection from '@/components/collection'

// component instance
var Hero = Vue.component('hero', {
  name: 'Hero',
  mixins: [sectionBase],
  components: { Collection },
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Hero
</script>

<style lang="scss" scoped>
  .hero{

  }
  .page-title{

  }
  .image{
    transform-origin: top center;
    // width: 210px;
    // height: 210px;
    text-align: center;
    margin: 0 auto;
  }
  // OPTIMIZE: positioning description in between first two collections
  #herodesc{
    position: absolute;
    top: 85vh;
    left: 0;

    width: 100%;
    padding: 0 25%;
    text-align: center;
    // p{ text-align: inherit; line-height: 1.8}

    &:before{
      content: '';
      position: absolute;
      display: block;

      width: 22px;
      height: 14px;

      margin-top: -#{measure(s)};
      left: 50%;
      margin-left: -11px;

      background: transparent url('../../'+$img_dir+'arrow-down.svg') top center no-repeat;
      background-size: 100% auto;
    }
  }
  .row:first-child{
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/hero.vue